import { initializeMobileHeader } from './includes/mobileHeader.js';
import { initializeDesktopHeader } from './includes/desktopHeader.js';

const solidHeaderTransitionPoint = 100;
const solidHeaderClass = 'solid-header';
const stickyHeaderClass = 'sticky-header';
const headerShowClass = 'header-show';

export const initializeHeader = () => {
    initializeDesktopHeader();
    initializeMobileHeader();
    initializeStickyHeader();
}

const initializeStickyHeader = () => {
    let lastScrollTop = 0;
    const headers = document.querySelectorAll('header');
    if (headers.length === 0) {
        return;
    }

    window.addEventListener('scroll', () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const body = document.body;
        if (scrollTop >= solidHeaderTransitionPoint) {
            headers.forEach(header => header.classList.add(solidHeaderClass));
        } else {
            headers.forEach(header => header.classList.remove(solidHeaderClass));
        }

        if (scrollTop > 0) {
            body.classList.add(stickyHeaderClass);
            if (scrollTop > lastScrollTop) {
                body.classList.remove(headerShowClass);
            } else if (scrollTop < lastScrollTop) {
                body.classList.add(headerShowClass);
            }
            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        } else {
            body.classList.remove(stickyHeaderClass, headerShowClass);
        }
    });
}
